import Vue from '@vue/compat';
import authorHeaderOptions from './author-header.js';
import commentsPageOptions from './comments-page.js';
import dynamicPageOptions from './dynamic-page.js';
import favoritePageOptions from './favorite-page.js';
import followsPageOptions from './follows-page.js';

function mountPage(selector, options) {
  if (!document.querySelector(selector)) return null;
  return new Vue({ el: selector, ...options });
}

window.qkAuthor = mountPage('.author-header', authorHeaderOptions);
window.followsPage = mountPage('.follows-page', followsPageOptions);
window.commentsPage = mountPage('.comments-page', commentsPageOptions);
window.dynamicPage = mountPage('.dynamic-page', dynamicPageOptions);
window.favoritePage = mountPage('.favorite-page', favoritePageOptions);

export {
  authorHeaderOptions,
  commentsPageOptions,
  dynamicPageOptions,
  favoritePageOptions,
  followsPageOptions,
};
